import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { CheckoutSignatureStatus } from 'src/common/enumerations/checkout-signature-status';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { TenderingState, DigitalReceiptOptions } from '../../interfaces/states/TenderingState';

export const initialState: TenderingState = {
  isProcessingSignature: false,
  isOwnBagDisabled: false,
  paymentInfoText: '',
  signatureInfo: '',
  signatureImageData: '',
  changeDue: 0,
  cashback: 0,
  disableGiftReceipt: true,
  digitalReceiptDetail: {},
  digitalReceiptOptions: {},
  waitForDrawerClose: false,
  signatureStatus: CheckoutSignatureStatus.None,
  tabValue: 1,
  salesKeypad: true,
  isTendering: false,
  ewicEpsUtilizedAmountTotal: 0,
  ewicReceipts: [],
  grandTotal: 0,
  // hasUnusedCoupons: false,
};

class TenderingReducer extends ImmerReducer<TenderingState> {
  public setState(state: Partial<TenderingState>): void {
    this.draftState = { ...this.draftState, ...state };
  }

  public resetState(): void {
    this.draftState = initialState;
  }

  public setDigitalReceiptOptions(digitalReceiptOptions: Partial<DigitalReceiptOptions>): void {
    this.draftState.digitalReceiptOptions = {
      ...this.draftState.digitalReceiptOptions,
      ...digitalReceiptOptions,
    };
  }

  public setIsProcessingSignature(isProcessingSignature: boolean): void {
    this.draftState.isProcessingSignature = isProcessingSignature;
  }

  public setIsOwnBagDisabled(isOwnBagDisabled: boolean): void {
    this.draftState.isOwnBagDisabled = isOwnBagDisabled;
  }

  public setPaymentInfoText(info: string, amount?: string, cardType?: string): void {
    this.draftState.paymentInfoText = info;
    if (amount) {
      this.draftState.amount = amount;
    }
    if (cardType) {
      this.draftState.cardType = cardType;
    }
  }

  public setWaitForDrawerClose(drawerOpen: boolean): void {
    this.draftState.waitForDrawerClose = drawerOpen;
  }

  public setEwicReceipts(ewicReceipts: IReceipt[]): void {
    this.draftState.ewicReceipts = ewicReceipts;
  }

  public setEwicEpsUtilizedAmountTotal(EwicEpsUtilizedAmountTotal: number): void {
    this.draftState.ewicEpsUtilizedAmountTotal = EwicEpsUtilizedAmountTotal;
  }

  public resetEwicEpsUtilizedAmountTotal(): void {
    this.draftState.ewicEpsUtilizedAmountTotal = 0;
  }

  public resetEwicReceipts(): void {
    this.draftState.ewicReceipts = [];
  }
  public setChangeDue(changeDue: number): void {
    this.draftState.changeDue = changeDue;
  }

  public setGrandTotal(grandTotal: number): void {
    this.draftState.grandTotal = grandTotal;
  }
  // Can be used once we get tenderAdd migrated
  // public setUnusedCoupon(hasUnusedCoupons: boolean): void {
  //   this.draftState.hasUnusedCoupons = hasUnusedCoupons;
  // }

  public setCashback(cashback: number): void {
    this.draftState.cashback = cashback;
  }

  public setIsTendering(isTendering: boolean): void {
    this.draftState.isTendering = isTendering;
  }

}
export const TenderingActions = createActionCreators(TenderingReducer);
export const TenderingReducerFunction = createReducerFunction(TenderingReducer, initialState);
